import {
  GetReservationConfigQuery,
  GetReservationConfigQueryVariables,
} from '../__generated__/graphql';
import { GET_RESERVATION_CONFIG } from '../graphql/getReservationConfig';
import { flashApolloError } from '../util/errorUtils';
import { useQuery } from '@apollo/client';

interface UseGetReservationConfigResponse {
  isLoadingReservationConfig: boolean;
  reservationConfig?: GetReservationConfigQuery['getReservationConfig'];
}

export default function useGetReservationConfig({
  tenantId,
  locationId,
}: GetReservationConfigQueryVariables): UseGetReservationConfigResponse {
  const res = useQuery<GetReservationConfigQuery, GetReservationConfigQueryVariables>(
    GET_RESERVATION_CONFIG,
    {
      fetchPolicy: 'network-only',
      onError: flashApolloError,
      variables: {
        locationId,
        tenantId,
      },
    }
  );

  return {
    isLoadingReservationConfig: res.loading,
    reservationConfig: res.data?.getReservationConfig,
  };
}
